import { render } from "./text-label.vue?vue&type=template&id=4cddd57b&scoped=true"
import script from "./text-label.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-label.vue?vue&type=script&setup=true&lang=ts"

import "./text-label.vue?vue&type=style&index=0&id=4cddd57b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cddd57b"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4cddd57b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cddd57b', script)) {
    api.reload('4cddd57b', script)
  }
  
  module.hot.accept("./text-label.vue?vue&type=template&id=4cddd57b&scoped=true", () => {
    api.rerender('4cddd57b', render)
  })

}

script.__file = "resources/ts/components/elements/text-label.vue"

export default script